import React, { useState } from 'react';
import moment from 'moment';

import AccommodationSearchFormCompact from '../AccommodationSearch/components/AccommodationSearchFormCompact';

const API_DATE_FORMAT = 'YYYY-MM-DD';

const TravelSearchCompact = () => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);

  function search(e) {
    e.preventDefault();

    const searchUrl = new URL(drupalSettings.travelsearch_page);

    searchUrl.searchParams.append(
      'startDate',
      startDate ? moment(startDate).format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append(
      'endDate',
      endDate ? moment(endDate).format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append('adults', adults);
    searchUrl.searchParams.append('children', children);

    window.location.href = searchUrl;
  }

  return (
    <div className="travel-search-external-form">
      <AccommodationSearchFormCompact
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        adults={adults}
        setAdults={setAdults}
        maxGuests={14}
        kids={children}
        setChildren={setChildren}
        onSubmit={search}
        buttonText={Drupal.t(
          'Search',
          {},
          { context: 'Travel search external' }
        )}
        availabilityFound={true}
        roomAllowsPets={false}
        allowInfants={false}
        popularDatesLabel={Drupal.t('Or choose from quick links')}
        adultsLabel={Drupal.t('Adults')}
        kidsLabel={Drupal.t('Kids 0-12 yrs')}
        startDatePlaceholderText={Drupal.t('Arrival')}
        endDatePlaceholderText={Drupal.t('Departure')}
      />
    </div>
  );
};

export default TravelSearchCompact;
